import React, { useState, useEffect } from 'react';

import "./dashboardMobileParticipantInnerDetail.css";


interface HoverModalProps {
    participant_name: string;
    cnt_indeterminate: number;
    cnt_pos: number;
    timeline: number;
    interval_counts : any;
    onClick : () => void;
}

function convertToHoursAndMinutes(intervals: number): string {
    const totalMinutes = intervals * 5;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
  
    if (hours > 0 && minutes > 0) {
      return `${hours} h ${minutes} min`;
    } else if (hours > 0) {
      return `${hours} h`;
    } else {
      return `${minutes} min`;
    }
}

function getAnomalyAndWarningPercentage(
    cnt_indeterminate: number,
    cnt_pos: number,
    timeline: number
): { anomalyPercentage: number; warningPercentage: number } {
    let timePeriod = timeline;
    
    const totalCounts = timePeriod * 24 * 12;
    
    const anomalyPercentage = (cnt_pos / totalCounts) * 100;
    const warningPercentage = ((cnt_indeterminate / totalCounts) * 100) + anomalyPercentage;
    
    return { anomalyPercentage, warningPercentage };
}

const DashboardMobileParticipantInnerDetail: React.FC<HoverModalProps> = ({ cnt_indeterminate = 0, cnt_pos = 0, participant_name, timeline, interval_counts, onClick }) => {
    const [anomaly, setAnomaly] = useState(0);
    const [warnings, setWarnings] = useState(0);

    const [isOneDay, setIsOneDay] = useState(true);

    useEffect(() => {
        // console.log("Timeline");
        // console.log(timeline);
        if(timeline === 1){
            setIsOneDay(true);
        }else{
            setIsOneDay(false);
        }
    }, [timeline]);

    return (
        <div className='dashboard-mobile-participant-inner-detail' onClick={onClick}>

            <div className='inner-detail-title'>
                <span className="title title-medium">{participant_name}</span>
            </div>
            
            <div style={{ height: '5px', width: '100%'}}></div>

            <div className='inner-detail-progress-bars'>
                {isOneDay ? (
                <>

                    <div className="progress-bar">
                        <div className="progress-inner1" style={{ width: `${getAnomalyAndWarningPercentage(cnt_indeterminate, cnt_pos, timeline).anomalyPercentage}%` }}></div>
                        <div className="progress-inner2" style={{ width: `${getAnomalyAndWarningPercentage(cnt_indeterminate, cnt_pos, timeline).warningPercentage}%` }}></div>
                    </div>

                </> )
                : (
                <>

                    {/* Now Build functions */}

                    <div className='progress-bar-vertical-container'>

                    {[...Array(timeline)].map((_, index) => {
                        const matchingInterval = interval_counts.find((item: any) => item.interval === index + 1);

                        return (

                            <>
                            
                                {matchingInterval ? (

                                    <div className="progress-bar-vertical">
                                        <div
                                            className="progress-inner1"
                                            style={{ height: `${getAnomalyAndWarningPercentage(matchingInterval.cnt_indeterminate, matchingInterval.cnt_pos, 1).anomalyPercentage}%` }}
                                        ></div>
                                        <div
                                            className="progress-inner2"
                                            style={{ height: `${getAnomalyAndWarningPercentage(matchingInterval.cnt_indeterminate, matchingInterval.cnt_pos, 1).warningPercentage}%` }}
                                        ></div>
                                    </div>


                                ) : (
                                    

                                    <div className="progress-bar-vertical">
                                        <div
                                            className="progress-inner1"
                                            style={{ height: `0%` }}
                                        ></div>
                                        <div
                                            className="progress-inner2"
                                            style={{ height: `0%` }}
                                        ></div>
                                    </div>

                                )}
                              
                            </>

                        );

                    })}



                    </div>

                    
                
                </> )
                }
            </div>

            <div style={{ height: '5px', width: '100%'}}></div>

            <div className='inner-detail-anomaly-text'>
                <span className='label label-medium'>{convertToHoursAndMinutes(cnt_pos)} Anomalies | {convertToHoursAndMinutes(cnt_indeterminate)} Warnings</span>
            </div>



            {/* {isAnomalous && (
                <>
                    <div className="progress-bar">
                        <div className="progress-inner1" style={{ width: `${anomaly}%` }}></div>
                        <div className="progress-inner2" style={{ width: `${warnings}%` }}></div>
                    </div>
                    
                    <div className='anamaly-indicator-text'>
                        <span className='label label-small'>{convertToHoursAndMinutes(cnt_pos)} Anomalies</span>
                        <span className='label label-small'>{convertToHoursAndMinutes(cnt_indeterminate)} Warnings</span>
                    </div>
                </>
            )} */}

        </div>
    );
};

export default DashboardMobileParticipantInnerDetail;